import script from "./AddNewPO.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewPO.vue?vue&type=script&setup=true&lang=js"

import "./AddNewPO.vue?vue&type=style&index=0&id=402ad5b0&lang=css"

const __exports__ = script;

export default __exports__